import React from "react";
import "./CovidPage.css";
import Banner from "../Component/covid19.jpg"; // 🖼️ Banner image

const CovidPage = () => {
  return (
    <div className="covid-page">
      {/* ✅ Banner Section */}
      <div className="covid-banner">
        <img src={Banner} alt="COVID Awareness Program" className="banner-img" />
      </div>

      {/* ✅ Content Section */}
      <div className="covid-content">
        <h2>COVID-19 Awareness Program at CPIT Institute</h2>
        <p>
          The <strong>Career Point of Information Technology (CPIT)</strong> organized a 
          <strong> “COVID-19 Awareness and Safety Program”</strong> aimed at spreading awareness 
          about the ongoing health concerns caused by the coronavirus pandemic. The initiative 
          was conducted as part of CPIT’s commitment to public health education and community welfare.
        </p>

        <h2>Objective of the Program</h2>
        <p>
          The main objective of the event was to educate students, staff, and the local community 
          about preventive measures, vaccination importance, and ways to stop the spread of infection. 
          Experts from the medical field and trained professionals were invited to provide practical 
          demonstrations and guidance on hygiene practices.
        </p>

        <h2>Program Highlights</h2>
        <ul>
          <li>🩺 Seminar on COVID-19 symptoms, prevention, and early detection.</li>
          <li>💉 Information session about the importance of vaccination and booster doses.</li>
          <li>🧴 Demonstration on proper hand hygiene and use of sanitizers.</li>
          <li>😷 Awareness walk organized within the campus promoting mask usage.</li>
          <li>📢 Distribution of informative brochures and safety kits to participants.</li>
        </ul>

        <h2>Key Message</h2>
        <p>
          The program emphasized the message — <strong>“Your Safety is Our Responsibility.”</strong>  
          CPIT urged everyone to continue practicing social responsibility, maintain hygiene, and support 
          health initiatives that ensure community safety.
        </p>

        <h2>About COVID-19</h2>
        <p>
          COVID-19 is a respiratory illness caused by the SARS-CoV-2 virus. It spreads primarily 
          through droplets from coughs, sneezes, or close contact with infected individuals. 
          Common symptoms include fever, cough, fatigue, and loss of taste or smell.
        </p>

        <h2>How to Protect Yourself</h2>
        <ul>
          <li>✅ Wash your hands frequently with soap and water.</li>
          <li>😷 Always wear a mask in crowded places.</li>
          <li>↔️ Maintain physical distancing of at least 1 meter.</li>
          <li>💉 Get vaccinated and stay updated with booster doses.</li>
          <li>🏠 Stay home if you feel unwell and seek medical advice.</li>
        </ul>

        <h2>Emergency Contacts</h2>
        <p>
          📞 <strong>National Helpline:</strong> +91-11-23978046  
          <br />
          📧 <strong>Email:</strong> ncov2019@gov.in
        </p>

        <h2>Conclusion</h2>
        <p>
          The <strong>COVID-19 Awareness Program</strong> organized by CPIT successfully encouraged 
          students and the local community to follow health guidelines and maintain safe practices. 
          Through education, demonstration, and community participation, CPIT continues to contribute 
          toward a healthier and more aware society.
        </p>
      </div>
    </div>
  );
};

export default CovidPage;
